import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../SchoolUniform/SchoolUniform.css";
import { SchoolUniform, UniformRules } from "../../Data/Data";
import { FaMale, FaFemale, FaRunning } from "react-icons/fa";

const getIcon = (category) => {
  if (category === "Boys") return <FaMale />;
  if (category === "Girls") return <FaFemale />;
  return <FaRunning />;
};

const SchoolUniformPage = () => {
  return (
    <div className="uniform-wrapper">

      {/* HEADER */}
      <div className="container text-center uniform-header">
        <h2 className="uniform-title">SCHOOL UNIFORM</h2>
        <p className="uniform-subtitle">
          Smart Dressing Builds Discipline & Confidence
        </p>
      </div>

      {/* CARDS */}
      <div className="container">
        <div className="row g-4">
          {SchoolUniform.map((group, index) => (
            <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-12">
              
              <div className="uniform-card">

                <div className="card-header-custom">
                  <span className="icon">{getIcon(group.category)}</span>
                  <h3>{group.category}</h3>
                </div>

                {group.sections.map((section, idx) => (
                  <div key={idx} className="season-block">
                    <h5 className="season-title">{section.season}</h5>

                    <ul>
                      {section.items.map((item, i) => (
                        <li key={i}>
                          <span className="dot"></span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}

              </div>

            </div>
          ))}
        </div>
      </div>

      {/* RULES */}
      <div className="container rules-section">
        <div className="rules-card">
          <h3 className="rules-title">⚠ Important Guidelines</h3>

          <div className="row">
            {UniformRules.map((rule, index) => (
              <div key={index} className="col-md-6 col-12 mb-2">
                <p className="rule-item">✔ {rule}</p>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
};

export default SchoolUniformPage;